import { db } from '../firebase';
import {
  collection,
  getDocs,
  query,
  where,
  doc,
  updateDoc,
  addDoc,
  deleteDoc,
  writeBatch,
} from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

export async function fetchRecebiveis(filtro) {
  const auth = getAuth();
  const userId = auth.currentUser?.uid;

  if (!userId) throw new Error('Usuário não autenticado');

  let q = query(collection(db, 'recebiveis'), where('userId', '==', userId));

  if (filtro.clinica) q = query(q, where('clinicaId', '==', filtro.clinica));
  if (filtro.plantao) q = query(q, where('plantaoId', '==', filtro.plantao));
  if (filtro.paciente) q = query(q, where('pacienteId', '==', filtro.paciente));
  if (filtro.status && filtro.status !== 'Todos')
    q = query(q, where('status', '==', filtro.status));

  const snapshot = await getDocs(q);
  return snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
}

export async function updateRecebivelStatus(id, newStatus) {
  const auth = getAuth();
  const userId = auth.currentUser?.uid;

  if (!userId) throw new Error('Usuário não autenticado');

  const recebivelRef = doc(db, 'recebiveis', id);
  await updateDoc(recebivelRef, { status: newStatus });
}

export async function addRecebivel(recebivel) {
  const auth = getAuth();
  const userId = auth.currentUser?.uid;

  if (!userId) throw new Error('Usuário não autenticado');

  const recebivelData = {
    ...recebivel,
    userId,
    createdAt: new Date(),
  };

  const docRef = await addDoc(collection(db, 'recebiveis'), recebivelData);
  return { id: docRef.id, ...recebivelData };
}

export async function deleteRecebivel(id) {
  const auth = getAuth();
  const userId = auth.currentUser?.uid;

  if (!userId) throw new Error('Usuário não autenticado');

  const recebivelRef = doc(db, 'recebiveis', id);
  await deleteDoc(recebivelRef);
}

export async function clearAllRecebiveis() {
  const auth = getAuth();
  const userId = auth.currentUser?.uid;

  if (!userId) throw new Error('Usuário não autenticado');

  const q = query(collection(db, 'recebiveis'), where('userId', '==', userId));
  const snapshot = await getDocs(q);

  const batch = writeBatch(db); // Correção: use writeBatch(db) para criar um novo batch
  snapshot.docs.forEach((doc) => {
    batch.delete(doc.ref);
  });

  await batch.commit();
}
